import { parseApiError } from './apiError';
const base = () => `${process.env.REACT_APP_API_URL}api/inspections`;

export const getAllInspections = async (token?: string) => {
  const res = await fetch(base(), {
    headers: token ? { 'Authorization': `Bearer ${token}` } : {}
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};
